// @ts-nocheck
import React from 'react'
import { Tabs, Tab } from 'material-ui'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'
import CalendarControl from '../event-calendar-control'
import AttendeeExport from '../attendee-export'
import Associations from '../associations'
import CreateMedia from './createMedia'
import selectOptions from '../../fieldOptions/webinarMediaTypes'

const associationFields = [
  { name: 'Add new media', prop: 'media_id', type: 'component', component: CreateMedia },
  { name: 'Media', prop: 'media_id', type: 'autocomplete', references: 'admin/media', referenceProp: 'name' },
  { name: 'Type', prop: 'media_type', type: 'select', options: selectOptions, enabled: true }
]

const associationColumns = [
  { name: 'ID', prop: 'id' },
  { name: 'Name', prop: 'name' },
  { name: 'URL', prop: 'url' }
]

class EditWebinar extends React.Component<any, any> {
  render () {
    const { webinarId, courseId, curriculumId } = this.props.params
    let partialPath = ''
    let label = 'Guest'

    if (courseId) {
      partialPath = `/courses/${courseId}`
      label = 'Course'
    } else if (curriculumId) {
      partialPath = `/curriculums/${curriculumId}`
      label = 'Curriculum'
    }

    return (
      <Tabs>
        <Tab label='Webinar Details'>
          <div>
            <Edit
// @ts-ignore
              title={`Edit ${label} Webinar`}
              fields={fields}
              apiPath={`admin/webinars/${webinarId}`}
              successRedirectPath={`/events${partialPath}/webinars`}
              buildMenuItems={menuItems}
            />
            <CalendarControl targetId={webinarId} targetType='webinar' />
            <AttendeeExport webinarId={parseInt(webinarId)} />
          </div>
        </Tab>
        <Tab label='Add Media'>
          <Associations
// @ts-ignore
            title='Webinar Media'
            fields={associationFields}
            columns={associationColumns}
            baseRecord={{ target_id: webinarId, target_type: 'webinar' }}
            joinApiPath='admin/media_targets'
            associationApiPath='admin/media'
            joinApiQuery={{ 'filters[target_id]': webinarId, 'filters[target_type]': 'webinar' }}
            associationIdField='media_id'
          />
        </Tab>
      </Tabs>
    )
  }
}

export default EditWebinar
